import { render, staticRenderFns } from "./MenuHelp.vue?vue&type=template&id=d6e3060c&"
import script from "./MenuHelp.vue?vue&type=script&lang=js&"
export * from "./MenuHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports